var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Navbar'),_c('div',{staticClass:"card-container"},_vm._l((_vm.products),function(product){return _c('CardProduct',{key:product.id,attrs:{"itemData":product}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }